import React from 'react';
import { XGridDefaultColumn } from '@AMIEWEB/Common/XGrid/cells/XGridDefaults';
import { GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import { GridColumns } from '@mui/x-data-grid';
import { missingField } from 'app/constants';
import i18next from 'i18next';
import { XGridRadioCell } from '@AMIEWEB/Common/XGrid/cells/XGridRadioCell';

interface IUnitGridFields {
  id: number;
  unitId: number;
  name: string;
  orders: number;
  positionsAvailable: number;
  skillset: string;
  status: string;
  lastUpdated: string;
  lastUpdatedBy: string;
}

const getColumn = (field: string, headerName: string, width: number, flex: number = 0, type: string = 'string') => {
  return {
    ...XGridDefaultColumn,
    field: field,
    headerName: headerName,
    flex: flex ?? 0,
    width: width,
    type: type,
  };
};

const SelectHeader = () => {
  return (
    <>
      <span style={{ fontWeight: 500 }}>{i18next.t('order.newOrderCreation.unitCreation.select')}</span>
    </>
  );
};
const unitColumnsNewOrderCreation = (): GridColumns => {
  return [
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      renderHeader: SelectHeader,
      renderCell: XGridRadioCell,
    },
    getColumn('name', 'Unit Name', 80, 1),
    getColumn('unitId', 'Unit ID', 70, 0),
    getColumn('orders', 'Orders', 70, 0, 'number'),
    getColumn('positionsAvailable', 'Positions', 80, 0, 'number'),
    getColumn('skillset', 'Skill Set', 250, 1),
    getColumn('status', 'Status', 100, 0),
    getColumn('lastUpdated', 'Last Updated', 100, 0),
    getColumn('lastUpdatedBy', 'Updated By', 100, 0),
  ];
};

const getFormattedRows = (units): IUnitGridFields[] => {
  return units?.map((item, index: number) => ({
    ...item,
    id: item?.unitId,
    unitId: item?.unitId ?? missingField,
    name: item?.unitName ?? missingField,
    orders: item?.orders ?? missingField,
    positionsAvailable: item?.positionsAvailable ?? missingField,
    skillset: item?.skillset ?? missingField,
    status: item?.status ?? missingField,
    lastUpdated: item?.lastUpdated ?? missingField,
    lastUpdatedBy: item?.lastUpdatedBy ?? missingField,
  }));
};
export { unitColumnsNewOrderCreation, getFormattedRows };
